export default __webpack_public_path__ + "static/media/slider3.27f95c25.png";